import { NotificationBar as CXNotificationBar } from '@sanlamcx/react-ui-next-notification-bar';

export type NotificationBar = typeof CXNotificationBar;
export const NotificationBar: NotificationBar = CXNotificationBar;
